if (!customElements.get('cookie-banner')) {
  customElements.define(
    'cookie-banner',
    class CookieBanner extends ModalElement {
      constructor() {
        super();

        // Il banner del consenso non passa da initWhenVisible come gli altri
        // popup. Quello rimanda l'avvio alla prima interazione o a 5 secondi,
        // e lo fa dentro un requestAnimationFrame, che resta fermo finche' la
        // pagina non renderizza: sui dispositivi touch il banner arrivava
        // quindi a 10 secondi, o non arrivava affatto. age-verifier, che e'
        // l'altro adempimento del tema, chiama init() direttamente. Qui
        // facciamo lo stesso: un obbligo di legge non e' rimandabile per
        // guadagnare prestazioni.
        this.init();
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }

      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 180;
      }

      get cookieName() {
        return 'concept:cookie-banner';
      }

      get acceptButton() {
        return this.querySelector('button[name="accept"]');
      }
    
      get declineButton() {
        return this.querySelector('button[name="decline"]');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
    
        if (this.testMode) {
          this.load(this.delay);
          return;
        }
    
        window.Shopify.loadFeatures([{
          name: 'consent-tracking-api',
          version: '0.1',
          onLoad: this.onConsentLibraryLoaded.bind(this)
        }]);
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
    
        if (this.acceptButton) this.acceptButton.addEventListener('click', this.acceptPolicy.bind(this));
        if (this.declineButton) this.declineButton.addEventListener('click', this.declinePolicy.bind(this));
      }
    
      acceptPolicy() {
        this.hide();
        this.setCookie(this.cookieName, this.expiry);
        window.Shopify.customerPrivacy?.setTrackingConsent(true, this.noop);
      }

      declinePolicy() {
        this.hide();
        this.setCookie(this.cookieName, this.expiry);
        window.Shopify.customerPrivacy?.setTrackingConsent(false, this.noop);
      }

      onConsentLibraryLoaded() {
        // Shopify non dice in modo affidabile se il visitatore ha gia' scelto:
        // getTrackingConsent() risponde 'no' sia alla prima visita sia dopo un
        // rifiuto, e shouldShowBanner() risponde sempre true. Il vecchio
        // confronto con 'no_interaction' non era quindi mai vero e il banner
        // non compariva mai. La scelta la ricordiamo con un cookie nostro,
        // come fanno age-verifier e newsletter-popup; il valore del consenso
        // resta di Shopify.
        const trackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

        if (trackingConsent !== 'yes' && !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }

      noop() {
      }

      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }

      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }

      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }

      afterHide() {
        super.afterHide();
        document.body.classList.remove('has-cookie-banner');

        // In modalita' prova il banner deve tornare a ogni ricarica
        if (this.testMode) this.removeCookie(this.cookieName);
      }
      afterShow() {
        super.afterShow();
        document.body.classList.add('has-cookie-banner');
      }
    }
  );
}
